import { shallowEqual, useSelector } from 'react-redux';
import { getPayoutAmount } from '../selectors';

export const usePayoutReceive = () => ({
  amount: useSelector(getPayoutAmount, shallowEqual),
});
